import { Toast } from "vant";

export const toast = (message = "", icon = "", duration = 1500) => Toast({ message, icon, duration });

// 自定义加载图标
export const loading = (message = "", duration = 1500, loadingType = "") =>
	Toast.loading({ message, duration, loadingType, forbidClick: true });

export const successToast = (title = "") => {
	Toast.success(title);
};

export const errorToast = (title = "") => {
	Toast.fail(title);
};
